$(document).ready(()=>{

    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });


    $('[data-toggle]').on('click', function()
    {
        let $this = $(this);
        let toggle_name = $(this).attr('data-toggle');
        let target_name = $(this).attr('data-target');
        let target_element = $('[data-toggle="showbox"][data-target="'+target_name+'"]');
        if(toggle_name == 'openbox')
        {
            let target_status = target_element.attr('data-status');
            $('[data-toggle="showbox"]:not([data-target="'+target_name+'"])').attr('data-status',false);
            $('[data-toggle="openbox"]:not([data-target="'+target_name+'"])').attr('data-status',false);
            if(target_status == 'false')
            {
                target_element.attr('data-status',true);
                $this.attr('data-status',true);
            }
            else
            {
                target_element.attr('data-status',false);
                $this.attr('data-status',false);
            }
        }
        else if(toggle_name == 'closebox')
        {
            target_element.attr('data-status',false);
            $this.attr('data-status',false);
        }
    });

    $(document).on('click',function(){
        $('[data-toggle="showbox"]').attr('data-status',false);
        $('[data-toggle="openbox"]').attr('data-status',false);
    });

    $(document).on('keyup',function(e) {
        if (e.key === "Escape") {
            $('[data-toggle="showbox"]').attr('data-status',false);
            $('[data-toggle="openbox"]').attr('data-status',false);
        }
    });

    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function(event){
        event.stopPropagation();
    });



    // Tabs
    //=====================================================================

    $(document).on('click','li[data-tab]',function(){
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');

        $this.addClass('active')
            .siblings()
            .removeClass('active');

        $('.tab-content[data-tab-target="'+target+'"][data-tab="'+tab+'"]')
            .addClass('active')
            .siblings()
            .removeClass('active');


        if(target == 'client')
        {
            interior_floor_slider.update();
            interior_floor_slider_pics.update();
            exterior_floor_slider.update();
            exterior_floor_slider_pics.update();
        }
    });


    $(document).on('mouseover','li[data-tab-hover]',function(){
        let $this = $(this),
            tab = $this.data('tab-hover'),
            target = $this.data('tab-target');

        $this.addClass('active')
            .siblings()
            .removeClass('active');

        $('.tab-content[data-tab-target="'+target+'"][data-tab="'+tab+'"]')
            .addClass('active')
            .siblings()
            .removeClass('active');
    });


    // Toaster Alert
    //=====================================================================

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });


    $(window).scroll(()=> {
        var scroll = $(window).scrollTop();
        if(scroll > 100)
        {
            $('body').addClass('body--header-fix')
        }
        else
        {
            $('body').removeClass('body--header-fix')
        }
    });




    setTimeout(()=>{
        $('.selectpicker').each((i,e)=>{
            let $this = $(e);
            let title = $this.data('placeholder');
            if(!$this.siblings('.dropdown-toggle').hasClass('filled'))
            {
                $this.siblings('.dropdown-toggle').addClass('filled')
                    .prepend('<span>'+title+'</span>');
            }
        });
    },300);


    if($('.projects__locations').length >= 1)
    {
        var map = L.map('projects__locations').setView([23.586745, 58.396031], 13);

        

        // L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
        //     maxZoom: 18,
        //     attribution: '',
        //     id: 'mapbox/streets-v11',
        //     tileSize: 512,
        //     zoomOffset: -1
        // }).addTo(map);

        let myFilter = [
            'grayscale:100%',
            'invert:100%',
        ]

        let myTileLayer = L.tileLayer.colorFilter('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
            attribution: '',
            filter: myFilter,
        }).addTo(map);


        var map_icon = L.icon({
            iconUrl: './assets/img/logo-mini.png',
            iconSize: [27, 40],
            iconAnchor: [27, 40],
            popupAnchor: [0, -40]
        });


        var data = {
            "locations":
            [
                {"latlng":[23.586745, 58.396031], "popup":
                    {
                        "link":"#1",
                        "image":"./assets/img/about.jpg",
                        "title":"Mohammed Aljahdhami House",
                        "desc":"To transform our client’s project into a product that we manufacture with confidence and without causing the client any hardship."
                    }
                },
                {"latlng":[23.596745, 58.456031], "popup":
                    {
                        "link":"#1",
                        "image":"./assets/img/about.jpg",
                        "title":"Mohammed Aljahdhami House",
                        "desc":"To transform our client’s project into a product that we manufacture with confidence and without causing the client any hardship."
                    }
                },
                {"latlng":[23.556745, 58.336031], "popup":
                    {
                        "link":"#1",
                        "image":"./assets/img/about.jpg",
                        "title":"Mohammed Aljahdhami House",
                        "desc":"To transform our client’s project into a product that we manufacture with confidence and without causing the client any hardship."
                    }
                },
            ]
        };

        var locations = [];
        $.each(data.locations,(i,e)=>{
            var popup_html = `
            <div class="projects__locations__popup__wrapper">
                <div class="projects__locations__popup__image">
                    <a href="`+e.popup.link+`">
                        <img src="`+e.popup.image+`" title="`+e.popup.title+`" alt="`+e.popup.title+`">
                    </a>
                </div>
                <div class="projects__locations__popup__content">
                    <div class="projects__locations__popup__title">
                        <h2><a href="`+e.popup.link+`" title="`+e.popup.title+`">`+e.popup.title+`</a></h2>
                    </div>
                    <div class="projects__locations__popup__desc">
                        <p>`+e.popup.desc+`</p>
                    </div>
                    <div class="projects__locations__popup__btn">
                        <a class="btn btn-success" href="`+e.popup.link+`" title="`+e.popup.title+`">MORE</a>
                    </div>
                </div>
            </div>
            `;

            locations[i] = L.popup({className: 'projects__locations__popup',maxWidth: 370})
            .setLatLng(e.latlng)
            .setContent(popup_html);
            L.marker(e.latlng,{icon:map_icon,}).addTo(map).bindPopup(locations[i]);
        });
    }


    if($('.contactus__location').length >= 1)
    {
        var contact_map = L.map('contactus__location').setView([23.586745, 58.396031], 13);

        // L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
        //     maxZoom: 30,
        //     attribution: '',
        //     id: 'mapbox/streets-v11',
        //     tileSize: 512,
        //     zoomOffset: -1
        // }).addTo(contact_map);

        let myFilter = [
            'grayscale:100%',
            'invert:100%',
        ]

        let myTileLayer = L.tileLayer.colorFilter('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
            attribution: '',
            filter: myFilter,
        }).addTo(contact_map);

        var map_icon = L.icon({
            iconUrl: './assets/img/logo-mini.png',
            iconSize: [27, 40],
            iconAnchor: [27, 40],
            popupAnchor: [0, -40]
        });

        L.marker([23.586745, 58.396031],{icon:map_icon,}).addTo(contact_map);
    }

    


    var project_slider = new Swiper('.project-detail__image .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: 1,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: 0
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });


    
    $(document).on('click','.team__item',function(){
        $(this).toggleClass('team__item--active')
    });


    var feedback_slider = new Swiper('.feedback__list .swiper-container', {
        slidesPerView: 'auto',
        direction: 'vertical',
        spaceBetween: 80,
        speed: 2000,
        loop: 1,
        autoplay: {
            delay: 2000,
            disableOnInteraction: 0
        },
    });

    var project_slider = new Swiper('.home-page__background .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: 1,
        speed: 2000,
        effect: 'fade',
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        fadeEffect: {
            crossFade: false
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: 0
        }
    });



    function readURL(input)
    {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                let ele = $(input).parent().data('uplaod-address');
                $('[data-upload="'+ele+'"]').val(input.files[0].name);
            }
            reader.readAsDataURL(input.files[0]);
        }
    }

    $(document).on('change','.upload-file input[type="file"]',function(){
        readURL(this);
    });


    $('.venobox').venobox();

    
    $('.project_info_path').addClass('loaded');

    var interior_floor_slider_pics = new Swiper('.interior_floor_slider_pic .swiper-container', {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        simulateTouch:false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    var interior_floor_slider = new Swiper('.interior_floor_slider .swiper-container', {
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        simulateTouch:false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        thumbs: {
            swiper: interior_floor_slider_pics,
        }
    });

    var exterior_floor_slider_pics = new Swiper('.exterior_floor_slider_pic .swiper-container', {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        simulateTouch:false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    var exterior_floor_slider = new Swiper('.exterior_floor_slider .swiper-container', {
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        simulateTouch:false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        thumbs: {
            swiper: exterior_floor_slider_pics,
        }
    });

    $(document).on('click','.floor_list > ul > li',function(){
    	var $this = $(this);
    	var type = $this.data('type');
        var img = $this.data('img');
    	var view = $this.data('view');
        if(view == 'interior')
        {
            var $box = $('.interior_floor_view_box .floor_view');
            var $wrapper = $('.interior_floor_view_box');
        }
        else if(view == 'exterior')
        {
            var $box = $('.exterior_floor_view_box .floor_view');
            var $wrapper = $('.exterior_floor_view_box');
        }

    	$wrapper.removeClass('opened');
    	$box.html('');

    	if(type != '')
    	{
	    	if(type == 'img')
	    	{
	    		var data = '<img src="'+img+'">';
	    		$box.html(data);
	    		$wrapper.addClass('opened');
	    	}
	    	else if(type == 'img_360')
	    	{ 
                var data = '<a-scene embedded  vr-mode-ui="enabled: false"><a-sky src="'+img+'" rotation="0 -130 0"></a-sky></a-scene>';
	    		$box.html(data);
	    		$wrapper.addClass('opened');
	    	}
	    	else if(type == 'img_pano')
	    	{
	    		var data = '<div class="pavar_view"><img src="'+img+'"></div>';
	    		$box.html(data);
	    		$('.pavar_view').paver();
	    		$wrapper.addClass('opened');
	    	}

	    	$('html, body').animate({scrollTop: ($wrapper.offset().top - 35)},500);
    	}
	});

    //=============================//
    // r.dadkhah.tehrani@gmail.com //
    //=============================//
});
